module.exports = __webpack_public_path__ + "media/images/loader-22555b55def970341edff4aece6671fa.gif";